<template>
  <div class="wrapper">
    <div class="title">扫码填写考试资料</div>
    <qrcode :value="qrcode" :options="{ width: 210 }"></qrcode>
  </div>
</template>

<script>
import { getUuid, setFormConfigId, setToken } from '@/utils/common'
import { getUserInfo } from '@/services/api'

let timer = null
const timerInterval = 3000

export default {
  name: 'QrCode',
  data() {
    return {
      content: '',
    }
  },
  computed: {
    qrcode() {
      return JSON.stringify({ QRCodeId: this.content })
    },
  },
  created() {
    this.checkQuery()

    const uuid = getUuid()
    this.content = uuid
    this.setTimer()
  },

  destroyed() {
    this.clearTimer()
  },
  methods: {
    checkQuery() {
      const query = this.$route.query
      if (query.token && query.formConfigId) {
        this.$router.push({ name: 'form', query })
      }
    },

    getData() {
      getUserInfo(this.content).then(res => {
        console.log('timer', res)
        if (res && res.token) {
          const { formConfigId, token, enrollId, branchId, centerId } = res
          this.clearTimer(timer)
          this.$router.push({
            name: 'form',
            query: { formConfigId, token, enrollId, branchId, centerId },
          })
        }
      })
    },

    setTimer() {
      this.getData()
      timer = setInterval(() => {
        this.getData()
      }, timerInterval)
    },
    clearTimer() {
      clearInterval(timer)
    },
  },
}
</script>

<style scoped>
.wrapper {
  max-width: 400px;
  height: 400px;
  margin: 100px auto 0 auto;
  background: #ffffff;
  box-shadow: 0px 0px 48px rgba(0, 0, 0, 0.06);
  opacity: 1;
  border-radius: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  text-align: center;
  margin-top: 80px;
}
</style>
